import _http from './ipv6_http.js';
const host = window.location.host;

let baseURL = `https://ipv6.lnqwe.com`;
if (host.indexOf('apisdk.lnqwe') > -1) {
  baseURL = `https://ipv6.lnqwe.com`
} else {
  baseURL = `https://ipv6.leteng5.cn`
}
const http = _http.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  baseURL
});

export const getIpv6Api = (params) => {
  return http({
    url: '/getip',
    method: 'post',
    data: params
  });
};